import React from "react";
import { MdChat, MdClose } from "react-icons/md";
import DataQueryPanel from "./DataQueryPanel";

function DataQueryWidget() {
  const [isOpen, setIsOpen] = React.useState(false);

  // Close on Escape key
  React.useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen]);

  // Click outside to close
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Backdrop (click outside to close) */}
      {isOpen && (
        <div
          onClick={handleBackdropClick}
          className="fixed inset-0 z-[99]"
        />
      )}
      <DataQueryPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close data query chat" : "Open data query chat"}
        className={`fixed bottom-[30px] right-[35px] z-[100] flex h-[60px] w-[60px] items-center justify-center rounded-full bg-gradient-to-br from-brand-400 to-brand-600 shadow-lg outline-none transition duration-200 hover:shadow-xl ${
          isOpen ? "md-max:hidden" : ""
        }`}
      >
        {isOpen ? (
          <MdClose className="h-6 w-6 text-white" />
        ) : (
          <MdChat className="h-6 w-6 text-white" />
        )}
      </button>
    </>
  );
}

export default DataQueryWidget;
